/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { Box, Grid, Portal, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import 'moment/locale/pl'

import { Guarantee } from '../api/index'
import ButtonBox from '../components/ButtonBox'
import Section from '../components/Section'
import SectionHeader from '../components/SectionHeader'
import SelectableCard from '../components/SelectableCard'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import {
  ArrowLeft,
  ArrowRight,
  CancelIcon,
  CheckIcon,
  PrinterBigIcon,
  SaveIcon,
  ShieldIcon,
  TabletIcon,
} from '../icons'

function ControlsEditWarranty() {
  const { controlId, portalRef, onCancelClick } = useOutletContext()
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const [state, setState] = useState({
    hasGuarantee: false,
    producentGuaranteeDate: null,
    fnsGuaranteeDate: null,
    garantieGuaranteeDate: null,
  })
  const [saveBtnLoading, setSaveBtnLoading] = useState(false)
  useEffect(() => {
    Guarantee.getGuarantee(axiosPrivate, controlId)
      .then(({ data }) => setState(data))
      // eslint-disable-next-line no-console
      .catch((e) => console.error(e))
  }, [axiosPrivate, controlId])

  const onClick = (newState) => (e) => {
    e.preventDefault()
    setState((prevState) => ({ ...prevState, hasGuarantee: newState }))
  }

  // eslint-disable-next-line no-unused-vars
  const handleDateChange = (name) => (newValue) => {
    setState({ ...state, [name]: newValue })
  }

  const saveCarGuarantee = (redirect) => (e) => {
    e.preventDefault()
    setSaveBtnLoading(true)
    Guarantee.setGuarantee(axiosPrivate, controlId, state)
      .then(() => {
        setSaveBtnLoading(false)
        if (redirect) {
          navigate(redirect)
        }
      })
      // eslint-disable-next-line no-console
      .catch((er) => console.error(er))
  }

  const { t } = useTranslation()

  return (
    <div>
      <Section>
        <SectionHeader
          icon={<ShieldIcon />}
          title={t('warrantyTitle')}
          subtitle={t('warrantySubTitle')}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <SelectableCard
              onClick={onClick(true)}
              title={t('warrantyCardTitle1')}
              icon={<TabletIcon />}
              selected={state.hasGuarantee}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectableCard
              onClick={onClick(false)}
              title={t('warrantyCardTitle2')}
              icon={<PrinterBigIcon />}
              selected={!state.hasGuarantee}
            />
          </Grid>
        </Grid>
        {state.hasGuarantee && (
          <Box>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale="pl"
            >
              <DatePicker
                label={t('warrantyLabel1')}
                inputFormat="DD-MM-YYYY"
                value={state.producentGuaranteeDate}
                onChange={handleDateChange('producentGuaranteeDate')}
                renderInput={(params) => (
                  <TextField
                    name="producentGuaranteeDate"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ mt: 3 }}
                    {...params}
                  />
                )}
              />
              <DatePicker
                label={t('warrantyLabel2')}
                inputFormat="DD-MM-YYYY"
                value={state.fnsGuaranteeDate}
                onChange={handleDateChange('fnsGuaranteeDate')}
                renderInput={(params) => (
                  <TextField
                    name="fnsGuaranteeDate"
                    InputLabelProps={{ shrink: true }}
                    sx={{ mt: 3 }}
                    fullWidth
                    {...params}
                  />
                )}
              />
              <DatePicker
                label={t('warrantyLabel3')}
                inputFormat="DD-MM-YYYY"
                value={state.garantieGuaranteeDate}
                onChange={handleDateChange('garantieGuaranteeDate')}
                renderInput={(params) => (
                  <TextField
                    name="garantieGuaranteeDate"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ mt: 3 }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        )}
        <Portal container={portalRef.current}>
          <ButtonBox
            buttons={[
              {
                label: 'Wstecz',
                icon: <ArrowLeft fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: saveBtnLoading,
                  onClick: saveCarGuarantee(
                    `/controls/${controlId}/edit/carBasicData`,
                  ),
                },
              },
              {
                label: t('backToListBtnLabel'),
                icon: <CancelIcon />,
                props: {
                  variant: 'outlined',
                  color: 'primary',
                  onClick: onCancelClick,
                },
              },
              {
                label: 'Zapisz',
                icon: <SaveIcon fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: saveBtnLoading,
                  onClick: saveCarGuarantee(),
                },
              },
              {
                label: 'Zakończ',
                icon: <CheckIcon fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: saveBtnLoading,
                  onClick: saveCarGuarantee(`/controls/${controlId}/summary`),
                },
              },
              {
                label: t('nextBtnLabel'),
                icon: <ArrowRight fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: saveBtnLoading,
                  onClick: saveCarGuarantee(
                    `/controls/${controlId}/edit/reviewHistory`,
                  ),
                },
              },
            ]}
          />
        </Portal>
      </Section>
    </div>
  )
}

export default ControlsEditWarranty
